module.exports = __webpack_public_path__ + "img/icon_jxxm@2x.fcef6e22.png";